import React from 'react';
import { StyledDiv } from '../../Theme/CommonStyled';
import notFound from '../../Assets/images/notFound.svg';
import { useTranslation } from 'react-i18next';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledDiv
      height={'100%'}
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column">
      <StyledDiv pb={18} textAlign="center" mr={6}>
        <img src={notFound} alt={'404'} />
      </StyledDiv>
      <StyledDiv
        fontSize={10}
        textAlign="center"
        direction="rtl"
        color="secondaryText"
        mb={9}>
        {t('notFound.pageNotFound')}
      </StyledDiv>
    </StyledDiv>
  );
};

export default NotFoundPage;
